import React from 'react'
import { Link } from 'react-router-dom'
import './DataDeletionPage.css'

function DataDeletionPage() {
  return (
    <div className="data-deletion-page">
      <div className="data-deletion-hero">
        <div className="container">
          <h1>Data Deletion Instructions</h1>
          <p>How to request removal of your Facebook login-related account data</p>
        </div>
      </div>

      <div className="container">
        <div className="data-deletion-content">
          <section className="data-deletion-section">
            <h2>Request data deletion</h2>
            <p>
              If you signed in with Facebook and would like us to delete your Facebook-linked account data,
              please send a request through our <Link to="/contact">Contact Us</Link> page.
            </p>
            <p>
              Include your name, email address, and a note that you want your Facebook login data deleted.
              Once we receive your request, we will review it and delete the associated data from our systems.
            </p>
          </section>

          <section className="data-deletion-section">
            <h2>What will be removed</h2>
            <p>We may delete the following information connected to your Facebook login:</p>
            <ul>
              <li>Facebook-linked account identifiers</li>
              <li>Name, email, and profile information provided during Facebook login</li>
              <li>Authentication records used to access your account</li>
              <li>Any account data created from the Facebook sign-in flow</li>
            </ul>
          </section>

          <section className="data-deletion-section">
            <h2>Deletion timeline</h2>
            <p>
              We will process valid deletion requests and remove the related data within a reasonable time,
              typically within 30 days, unless a legal requirement requires retention.
            </p>
          </section>

          <section className="data-deletion-section">
            <h2>Need help?</h2>
            <p>
              If you have questions or need assistance, please visit the <Link to="/contact">Contact Us</Link> page
              and submit your request. We are here to help.
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default DataDeletionPage
